import mitt from 'mitt'

type ApplicationEvents = {
  'toggleModal': {
    open: boolean,
    content?: string
  }
};

const emitter = mitt<ApplicationEvents>()

export const useEvent = emitter.emit
export const useListen = emitter.on